/*
* PdfHorizontalContentContainer.js
* Created on 22-11-2017
* @author Olivier for &ranj
* 
* A horizontal container which contains a set amount of columns. Columns can have a set width, or it can be calculated based on the content within the column.
*/

import AbstractPdfContent from "./AbstractPdfContent";
import PdfTextContent from "./PdfTextContent";
import PdfVerticalContentContainer from "./PdfVerticalContentContainer";

export default class PdfHorizontalContentContainer extends AbstractPdfContent {
    constructor(columns, style) {
        super(style);

        this._columns = [];
        this._columnBorder = 0;

        let dist = [];
        for (let i = 0; i < columns; i++) {
            dist.push(100 / columns);
            this._columns.push(new PdfVerticalContentContainer());
            this._columns[i].parent = this;
        }

        this.setColumnWidthDistributionPct(dist);
        this.setPropertiesFromObject(style);
    }

    setPropertiesFromObject(obj) {
        super.setPropertiesFromObject(obj);

        for (let property in obj) {
            if (obj.hasOwnProperty(property)) {
                switch (property) {
                    case ("column1"): this.getColumn(1).setPropertiesFromObject(obj[property]); break;
                    case ("column2"): this.getColumn(2).setPropertiesFromObject(obj[property]); break;
                    case ("column3"): this.getColumn(3).setPropertiesFromObject(obj[property]); break;
                    case ("tableBorder"): this.setColumnBorder(obj[property]); break;
                }
            }
        }
    }

    //takes an array of floats. each value in the array defines the width percentage of a single column. 
    setColumnWidthDistributionPct(columnWidths) {
        if (this._columns.length !== columnWidths.length) {
            console.warn("[PdfHorizontalContentContainer] Received incorrect columnWidth distribution array.");
        }

        for (let i = 0; i < this._columns.length; i++) {
            this._columns[i].setWidth(this._width * (columnWidths[i] / 100));
        }
    }

    //takes an array of floats. each value in the array defines the width in pixels of a single column
    setColumnWidthDistribution(columnWidths) {
        if (this._columns.length !== columnWidths.length) {
            console.warn("[PdfHorizontalContentContainer] Received incorrect columnWidth distribution array.");
        }

        for (var i = 0; i < this._columns.length; i++) {
            this._columns[i].setWidth(columnWidths[i]);
        }
    }

    setColumnBorder(size) {
        this._columnBorder = size;
    }

    //method for getting a specified column, can be used to set column properties such as background color. 
    //If you want to add content to the column, it's better to use the "addContentToColumn" or "addTextToColumn" methods.
    getColumn(index) {
        return this._columns[index - 1];
    }

    addContentToColumn(content, column) {
        column = column - 1;

        if (content.getWidth() === 0) {
            content.setWidth(this._columns[column].getWidth() - content.getPadding()[1] - content.getPadding()[3]);
        }
        this._columns[column].addContent(content);
        content.parent = this;
    }

    addTextToColumn(text, style, column) {
        let pdfText = new PdfTextContent(text, style);
        if (pdfText.getWidth() === 0) {
            pdfText.setWidth(this._columns[column - 1].getWidth() - pdfText.getPadding()[1] - pdfText.getPadding()[3]);
        }

        this._columns[column - 1].addContent(pdfText);
    }

    calculateBounds(doc) {
        let height = 0;

        for (let i = 0; i < this._columns.length; i++) {
            this._columns[i].calculateBounds(doc);

            height = Math.max(this._columns[i].getFullHeight(), height);
        }

        for (let i = 0; i < this._columns.length; i++) {
            this._columns[i].setHeight(height - this._columns[i].getPadding()[0] - this._columns[i].getPadding()[2]);
        }

        this.setHeight(height);
    }

    printToDocument(doc, x, y) {
        super.printToDocument(doc, x, y);

        let top = y + this._padding[0];
        let left = x + this._padding[3];

        //print columns to document
        for (let i = 0; i < this._columns.length; i++) {
            let curX = left;
            for (let j = 0; j < i; j++) {
                curX += this._columns[j].getWidth();
            }

            this._columns[i].printToDocument(doc, curX, top);

            if (this._columnBorder > 0) {
                //draw border
                doc.setLineWidth(this._columnBorder - 0.5);
                doc.setDrawColor(this._borderColor[0], this._borderColor[1], this._borderColor[2]);

                doc.rect(curX, top, this._columns[i].getWidth(), this._height);

                doc.setLineWidth(1);
            }
        }
    }
}